export default {
      id: "warning--no-bg-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#warning--no-bg",
      toString: function () {
        return this.url;
      }
    }